import { Feature } from '@tencent/workbench';
import { FillFeature } from './base/fill-feature';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { getPcInjectedService } from '@src/framework/workbench/util/injector-service';
import { ChartService } from '@src/framework/workbench/common/service/chart-service';
import { FillType, FillTypes, LINEAR_GRADIENT, LinearDirectOptions } from '../../../fill/constants';
import { DirectOptions } from './config';
import ChartShapeProperty from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import { ColorSelectButton } from '@framework/workbench/drawer/components/color-select-button';
import React from 'react';
import {
    TDWVer5Type,
    TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';
import { IFillFeature } from '@framework/workbench/drawer/ui/chart/common/fill/fill-interface';

import { handleInputBlurInitAndReset, IInputParams } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { AngleFrom, NumberInputFrom } from '@tencent/wb-ext-form';
import { opacityToAlpha } from '@src/framework/workbench/drawer/utils';

const DEFAULT_WHITE_COLOR = '#000000';

@Feature()
export class ChartFillFeature extends FillFeature implements IFillFeature {
    /**
     * 获取当前选中元素
     */
    public getSelectModel(): any {
        const model = super.getSelectModel();
        if (model?.type === UIModelType.CHART) {
            const chartService = (getPcInjectedService(ChartService) as ChartService);
            const selectedElementModel = chartService.getSelectedElementModel(model);
            return selectedElementModel;
        }
        return model;
    }

    public getFillDirectionOptions() {
        if (this.gradFill.value.curGradualType === LINEAR_GRADIENT) {
            return LinearDirectOptions;
        }
        return DirectOptions;
    }

    public getColorSelectButton() {
        return <ColorSelectButton
            onColorChange={(tdColor, from) => {
                this.solidFill.handleSolidColorChange(tdColor, from, false);
                this.getColorPickerManager()?.colorPickerTdwReport({
                    color: tdColor?.srgb_color,
                    colorPickerFrom: TDWVer6Type.COLOR_PICKER_DRAWER,
                    colorGroupFrom: from,
                    actionType: TDWVer5Type.COLOR_PICKER_FILL,
                });
            }}
            // todo: 选中态
            value={this.solidFill.value.solidFillColor || DEFAULT_WHITE_COLOR}
        />;
    }

    public updateFillProps(fill, onlyChangeUI?) {
        // 目前图表不支持 预览样式，目前采取脱手更新并保存
        if (onlyChangeUI) return;
        this.getSelectModel().updateFill(fill);
        // 更新active的渐变点的color
        // model更新之后会触发PropertyEditorManager handleShowPropertyDrawer, 子图表更新没有绑定该回调
        // 所以在这里更新后直接更新下activeGradualColor
        this.gradFill.value.activeGradualColor = this.gradFill.getActivePoint().bgColor;
    }

    public getFillTypes = () => {
        const fillTypes: {key: string, content: string}[] = [];
        const { fillColor } = this;
        const isPattFill = fillColor?.pattFill;
        const isImgFill = fillColor?.image;
        FillTypes.forEach((item) => {
            if ((item.key === FillType.PATT_FILL && !isPattFill)
                || (item.key === FillType.IMAGE_FILL && !isImgFill)) {
                // 图表图片和图案填充目前不支持设置，只能显示
            } else {
                fillTypes.push(item);
            }
        });
        return fillTypes;
    };

    @handleInputBlurInitAndReset()
    public handleSolidOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            // 避免数据重复提交。 case： 回车后再失焦，会触发两次change回调
            if (this.solidFill.value.solidFillColor.alpha === opacityToAlpha(opacity)) return;
            this.solidFill.handleSolidOpacityChange(opacity, from, dragEnd);
        } else {
            this.solidFill.handleSolidOpacityChange(opacity, from, dragEnd);
        }
    }

    @handleInputBlurInitAndReset()
    public handleGradualOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            // 避免数据重复提交。 case： 回车后再失焦，会触发两次change回调
            if (this.gradFill.value.activeGradualColor.alpha === opacityToAlpha(opacity)) return;
            this.gradFill.handleGradualOpacityChange(opacity, dragEnd, from);
        } else {
            this.gradFill.handleGradualOpacityChange(opacity, dragEnd, from);
        }
    }

    @handleInputBlurInitAndReset()
    public handleAngleChange(value: number, dragEnd?: boolean, from?: AngleFrom): void {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            // 避免数据重复提交。 case： 回车后再失焦，会触发两次change回调
            if (this.gradFill.value.gradualAngle === value) return;
            this.gradFill.handleAngleChange(value, dragEnd, from);
        } else {
            this.gradFill.handleAngleChange(value, dragEnd, from);
        }
    }

    public getInputParams(): IInputParams {
        return {
            key: INPUT_PROPS_CALLBACK_KEY.CHART_FILL,
        };
    }
}
